namespace InvData.Models {

   
    export class TagSet {

        public id: number;
        public code: string;
        public label: string;
        public maxLevel: number;
        public tags: IdAndCodeObjectIndex<Tag>;
        public rootTags: Tag[];

        constructor(tagSetData: JsonTagSet) {
            this.id = tagSetData.id ? tagSetData.id : null;
            this.code = tagSetData.code ? tagSetData.code : null;
            this.label = tagSetData.label ? tagSetData.label : null;

            this.maxLevel = 0;

            this.tags = new IdAndCodeObjectIndex<Tag>();
            this.rootTags = [];

            if (tagSetData.rootTags) {
                for (let i = 0; i < tagSetData.rootTags.length; i++) {
                    let rootTagData = tagSetData.rootTags[i];
                    let rootTag = this._loadTagData(rootTagData, null, 0, i);
                    this.rootTags.push(rootTag);
                }
            }
        }

        public _loadTagData(tagData, parentTagId: number, level: number, tagOrder: number) {
            var flatTagData: TagClassData = {
                id: tagData.id ? tagData.id : null,
                code: tagData.code ? tagData.code : null,
                label: tagData.label ? tagData.label : null,
                parentTagId: parentTagId,
                tagSet: this,
                level: level,
                tagOrder: tagOrder
            };

            this.maxLevel = Math.max(this.maxLevel, level);

            var childTagObjects = null;
            if (tagData.childTags && tagData.childTags.length > 0) {
                childTagObjects = [];

                for (let i = 0; i < tagData.childTags.length; i++) {
                    let childTagData = tagData.childTags[i];
                    let childTag = this._loadTagData(childTagData, flatTagData.id, level + 1, i);
                    childTagObjects.push(childTag);
                }
            }

            flatTagData.childTags = childTagObjects;

            var tag = new Tag(flatTagData);
            this.tags.add(tag);
            return tag;
        }

        public tryGetTagById(id: number): Tag {
            return this.tags.tryGetById(id);
        }

        public tryGetTagByCode(code: string): Tag {
            return this.tags.tryGetByCode(code);
        }

        /**
         * Return maximum level depth at which tags exist in this tag set.
         */
        public getMaxLevel(): number {
            return this.maxLevel;
        }

        /**
         * Return levelInfoGetter for use with data row grouping.
         */
        public getLevelInfoGetter() {
            var self = this;
            return function (groupValue) {
                var tag = self.tryGetTagById(groupValue);
                if (tag) {
                    return {
                        parent: tag.parentTagId,
                        level: tag.level
                    };
                }
                else {
                    return null;
                }
            };
        }
    }

}